import React,{useRef, useEffect}  from "react";
import { useTranslation } from 'react-i18next';
import ProductsCollection from './ProductsCollections';
import './productCollection.css';

const Collection = () => {
    const { t } = useTranslation();
    const containerRef = useRef(null);
    const scrollLeft = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({
                left: containerRef.current.scrollLeft - 900, // Adjust this value as needed
                behavior: 'smooth' // Smooth scrolling
            });
        }
    };

    const scrollRight = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({
                left: containerRef.current.scrollLeft + 900, // Adjust this value as needed
                behavior: 'smooth' // Smooth scrolling
            });
        }
    };
  return (
    <div className="collection-container">
        <h2 className='project-heading'>{t("ppe's")}</h2>
        <div className="products-container">
                {ProductsCollection.map((product) => {
                    console.log(product.image);
                    return (
                        <div className="collection">
                            <img
                                className="collection-image"
                                src={product.image}
                                alt={product.alt}
                            />
                            <p className="category-name">{product.category}</p>
                            <a className="overlay" href={`/products/${product.name.toLowerCase().replace(/\s/g, '')}`}>
                                <div className="animated-box">
                                    <span className="overlay-text">{product.name}</span>
                                </div>
                            </a>
                        </div>
                    );
                })}
        </div>
    
    </div>
    );
};

export default Collection;